import styled, { css } from "styled-components";
import { Palette } from "@styled-icons/boxicons-regular/Palette";
import { CodeBlock } from "@styled-icons/boxicons-regular/CodeBlock";
import { ObjectGroup } from "@styled-icons/fa-solid/ObjectGroup";

const titles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 167px;
`;
export const Container = styled.div`
  ${({ title }) => title && titles};
  padding: 0 100px;
  margin-bottom: 77px;
  @media (max-width: 1049px) {
    padding: 0 20px;
  }
  animation: meals-appear 1s ease-out forwards;

  @keyframes meals-appear {
    from {
      opacity: 0;
      transform: translateY(6rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Range = css`
  ::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 50%;
    width: 150px;
    height: 4px;
    background: crimson;
    transform: translateX(-50%);
  }
  ::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: crimson;
    transform: translateX(-50%);
  }
  margin-bottom: 60px;
`;

const ContentTitle = css`
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #000;
`;
const Info = css`
  color: crimson;
  font-size: 20px;
  font-weight: 700;
  margin: 10px;
`;
const Main = css`
  animation: meals 1s ease-out forwards;

  @keyframes meals {
    from {
      opacity: 0;
      transform: translateY(3rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
export const Title = styled.div`
  ${({ main }) => main && Main};
  position: relative;
  color: crimson;
  font-size: 35px;
  font-weight: 800;
  ${({ range }) => range && Range};
  ${({ contentTitle }) => contentTitle && ContentTitle};
  ${({ info }) => info && Info};
`;

const Content = css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;
const Card = css`
  background-color: #fff;
  width: 300px;
  margin: 30px;
  padding: 25px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(1 1 1 / 15%);
  transition: transform 0.5s ease;
  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;
const Icon = css`
  color: crimson;
  text-align: center;
  transition: transform 0.5s ease;
  :hover {
    cursor: pointer;
    transform: translateY(-10px);
  }
`;
export const Wrapper = styled.div`
  ${({ content }) => content && Content};
  ${({ card }) => card && Card};
  ${({ icons }) => icons && Icon};
  text-align: ${({ info }) => info && "center"};
`;
export const Desc = styled.p`
  width: ${({ desc }) => desc && "80%"};
`;
export const Icons = styled.div``;
Icons.Palette = styled(Palette)`
  width: 120px;
`;
Icons.CodeBlock = styled(CodeBlock)`
  width: 120px;
`;
Icons.ObjectGroup = styled(ObjectGroup)`
  width: 120px;
`;
